"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeModule = void 0;
const types_1 = require("../types");
/**
 * Represents a module for trading operations.
 */
class TradeModule {
    constructor(axios) {
        this._axios = axios;
    }
    /**
     * Get a quote for a trade request.
     * @param tradeRequest - The trade request body.
     * @returns A promise that resolves to the trade quote.
     * @throws If an error occurs during the request.
     */
    quote(tradeRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get('/v1/trade/quote', { params: tradeRequest.getParams() });
                if (response.status === 200) {
                    return types_1.TradeData.fromJson(response.data);
                }
                throw new Error('Failed to get quote');
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Retrieves the current price for the given token address.
     * @param tokenAddress - The address of the token.
     * @returns A promise that resolves to the token price.
     * @throws If an error occurs during the request.
     */
    price(tokenAddress) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get('/v0/trade/price/' + tokenAddress);
                if (response.status === 200) {
                    return (_a = response.data.data.price) !== null && _a !== void 0 ? _a : '0';
                }
                throw new Error('Failed to get price for token');
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Fetches the price change for a given token address.
     * @param tokenAddress - The address of the token.
     * @returns A promise that resolves to the token price change.
     * @throws If an error occurs during the request.
     */
    priceChange(tokenAddress) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get('/v0/trade/pricechange/' + tokenAddress);
                if (response.status === 200) {
                    return (_a = response.data['data']['priceChange']) !== null && _a !== void 0 ? _a : '0';
                }
                throw response;
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Retrieves the interval stats for a token with the given address and time frame.
     * @param tokenAddress - The address of the token.
     * @param timeFrame - The time frame for the interval stats.
     * @returns A promise that resolves to an array of interval stats.
     * @throws If an error occurs during the request.
     */
    interval(tokenAddress, timeFrame) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get('/v0/trade/pricechange/interval/' + timeFrame.toUpperCase() + '/' + tokenAddress);
                if (response.status === 200) {
                    return response.data.data.map((item) => {
                        return types_1.IntervalStats.fromJson(item);
                    });
                }
                throw response;
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Fetches the list of available tokens.
     * @returns A promise that resolves to an array of tokens.
     * @throws If an error occurs during the request.
     */
    fetchTokens() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get('/v0/trade/tokens');
                if (response.status === 200) {
                    return response.data.data.tokens.map((item) => {
                        return (0, types_1.parseTokenDetails)(item);
                    });
                }
                throw response;
            }
            catch (error) {
                throw error;
            }
        });
    }
}
exports.TradeModule = TradeModule;
